/* eslint-disable */
export default {
  createCallLog: '통화 기록 만들기',
  viewInSalesforce: 'Salesforce에서 보기',
  createLog: '기록 만들기',
} as const;

// @key: @#@"createCallLog"@#@ @source: @#@"Create call log"@#@
// @key: @#@"viewInSalesforce"@#@ @source: @#@"View in Salesforce"@#@
// @key: @#@"createLog"@#@ @source: @#@"Create log"@#@
